export default "__VITE_ASSET__CSrN69vO__"